<template>
    <div v-loading="displayLoading" class="col-lg-12">
        <div class="card">
            <span class="chartTitle">{{title}}</span>
            <el-date-picker
                    v-model="dateRange"
                    type="daterange"
                    placeholder="Wybierz zakres daty"
                    range-separator="-"
                    format="yyyy-MM-dd"
                    change="loading">
            </el-date-picker>

            <bar v-on:loader="loadingEvent" :range="dateRange" :localName="localName" :time="time" :url="url" :addMonths="addMonths" :type="type" :type_from="type_from"></bar>
        </div>
    </div>
</template>
<style>
    .el-date-editor {
        margin-left: 15px;
        margin-top: 15px;
    }

    .chartTitle {
        padding-left: 20px;
        font-weight: 600;
        color: #656565;
    }
</style>
<script>
  import Bar from './BarChart.js'

  export default {
    components: {
      Bar
    },
    props: {
      url: '',
      time: '',
      localName: '',
      title: '',
      addMonths: {
        default: false
      },
      type: {
        type: String,
        default: ''
      },
      type_from: {
        type: String,
        default: ''
      }
    },
    mounted () {
      this.getLastMonth()
    },
    data () {
      return {
        dateRange: [],
        displayLoading: false
      }
    },
    methods: {
      loadingEvent (load) {
        this.displayLoading = load
      },
      dateRangeChange (date) {
        this.dateRange = date
      },
      getLastMonth () {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        this.dateRange = [start, end]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BarChart.vue?194da216